import React from 'react';
import { styled } from '../../../stitches.config';

import Box from '../Box';

import logoTTTR from "../../../assets/SpecialCampaigns/IncredibleInspirations/logoTTTR.png"
import logoIncradible from "../../../assets/SpecialCampaigns/IncredibleInspirations/Incredibles_Logo_new.jpg"

export default props => {
    const isDesktop = window.innerWidth > 996;

    return (
        <Section className="container">
            <Logos>
                <div><img src={logoIncradible} /></div>
                <div className="smaller-logo"> Partner merytoryczny: <img src={logoTTTR} /></div>
            </Logos>
            <video autoPlay muted loop>
                <source src={`${window.STATIC_DOMAIN}/extra/incredible-inspirations/incredible_inspirations_${isDesktop ? 'desktop' : 'mobile'}.mp4`} type="video/mp4" />
            </video>
            <div className="col-xs-12 col-md-6">
                <Box {...props} id="b1" type={isDesktop ? "BTextOnPicture" : "BPhotoOnTop"} settings={props.settings.b1} style="with-padding" classes="" />
            </div>
            <div className="col-xs-12 col-md-6">
                <Box {...props} id="b2" type={isDesktop ? "BTextOnPicture" : "BPhotoOnTop"} settings={props.settings.b2} style="with-padding" classes="" />
            </div>
        </Section>
    );
}

const Section = styled("section", {
    marginTop: "20px",
    paddingTop: "14px",
    paddingBottom: "20px",
    overflow: "hidden",
    "@bp4": {
        paddingBottom: "50px"
    },
    "@media (min-width: 1200px)": {
        paddingBottom: "140px"
    },
    "& > img": {
        position: "absolute",
        top: "0",
        zIndex: 2,
        "@bp4": {
            width: "100%"
        }
    },
    "video": {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        zIndex: 1,
        height: "100%",
        "@bp4": {
            width: "auto",
            height: "100%"
        },
        "@media (min-width:1200px)": {
            width: "100%", height:
                "auto"
        }
    },
    "& > div": {
        zIndex: 3,
        "a": {
            borderRadius: "0",
            borderWidth: "0"
        }
    }
});

const Logos = styled("div", {
    display: "flex",
    fontSize: "18px",
    flexDirection: "column",
    alignItems: "center",
    color: "white",
    position: "relative",
    zIndex: 3,
    fontFamily: "$grotesk",
    "@media (min-width: 380px)": {
        fontSize: "24px"
    },
    "img": {
        width: "180px",
        "@media (min-width: 380px)": {
            width: "220px"
        },
        "@bp4": {
            marginTop: "10px"
        }
    },
    ".smaller-logo": {
        fontSize: "12px",
        marginBottom: "20px",
        "@media (min-width: 380px)": {
            fontSize: "14px"
        },
        "@bp4": {
            marginTop: "10px"
        },
        "@media (min-width: 1200px)": {
            marginTop: "25px"
        },
        "& > img": {
            width: "160px",
            "@media (min-width: 380px)": {
                width: "140px"
            },
            margin: "0"
        }
    }
});